// DarkBox theme — minimal client JS
(function () {
  // Cart count refresher
  function refreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => {
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = c.item_count;
        });
      })
      .catch(() => {});
  }
  document.addEventListener('DOMContentLoaded', refreshCart);

  // Smooth scroll for in-page anchors
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const id = a.getAttribute('href').slice(1);
    if (!id) return;
    const target = document.getElementById(id);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();
